import { useContext, useEffect, useRef } from "react";

import Approach from "../../components/marketing/howItWorks/Approach";
import AudienceFit from "../../components/marketing/howItWorks/AudienceFit";
import Capabilities from "../../components/marketing/howItWorks/Capabilities";
import Comparison from "../../components/marketing/howItWorks/Comparison";
import Engine from "../../components/marketing/howItWorks/Engine";
import Faq from "../../components/marketing/howItWorks/Faq";
import FinalCta from "../../components/marketing/howItWorks/FinalCta";
import Hero from "../../components/marketing/howItWorks/Hero";
import PlatformNotes from "../../components/marketing/howItWorks/PlatformNotes";
import Problems from "../../components/marketing/howItWorks/Problems";
import Solution from "../../components/marketing/howItWorks/Solution";
import Trust from "../../components/marketing/howItWorks/Trust";
import Footer from "../../components/marketing/engineering/Footer";
import Seo from "../../components/seo/Seo";
import { siteMetadata } from "../../content/siteMetadata";
import { ApplicationContext } from "../../context/GlobalState";
import { setPageMetadata } from "../../context/actions";
import MarketingLayout from "../../layouts/MarketingLayout";

const PAGE_TITLE =
  "How It Works | Always-On Technology Operations for Healthcare | Data Chimp Labs";
const PAGE_DESCRIPTION =
  "An always-on technology operations team for healthcare billing accuracy, system uptime, and security — with strict human-approval guardrails.";

/**
 * Standalone operations-focused landing page walking healthcare IT and
 * operations leaders through the watch/investigate/fix/verify capability set.
 * Translation: Standalone operations-focused landing page walking healthcare IT and
 * operations leaders through the watch/investigate/fix/verify capability set.
 *
 * @returns {JSX.Element} How It Works page.
 */
const HowItWorks = () => {
  const heroRef = useRef(null);
  const [, dispatch] = useContext(ApplicationContext);

  useEffect(() => {
    dispatch(
      setPageMetadata({
        title: PAGE_TITLE,
        description: PAGE_DESCRIPTION,
        image: siteMetadata.socialImage,
        pathname: "/how-it-works",
      })
    );
  }, [dispatch]);

  return (
    <>
      <Seo
        title={PAGE_TITLE}
        description={PAGE_DESCRIPTION}
        pathname="/how-it-works"
        image={siteMetadata.socialImage}
        imageAlt="Data Chimp Labs — Always-On Technology Operations for Healthcare"
        keywords={[
          "healthcare technology operations",
          "billing accuracy monitoring",
          "healthcare system uptime",
          "healthcare security monitoring",
          "hipaa compliant operations",
          "always-on ops team",
          "data chimp labs how it works",
        ]}
      />

      <MarketingLayout heroRef={heroRef} footer={<Footer minimal />}>
        <Hero heroRef={heroRef} />
        <Problems />
        <div className="glow-line" />
        <Solution />
        <Approach />
        <div className="glow-line" />
        <Engine />
        <div className="glow-line" />
        <Capabilities />
        <div className="glow-line" />
        <Trust />
        <div className="glow-line" />
        <Comparison />
        <div className="glow-line" />
        <AudienceFit />
        <div className="glow-line" />
        <PlatformNotes />
        <Faq />
        <FinalCta />
      </MarketingLayout>
    </>
  );
};

export default HowItWorks;
